import { ISelectionService } from '../../../selection/selection-service.interface';
import { ICommentApi, ICommentWithVipInfo, PendingCommentGroup } from '../type';

export interface IBaseCommentManager extends ICommentApi {
    /**
     * 侧边栏active的批注组id
     */
    activeGroupId: string | undefined;
    /**
     * 侧边栏hover的批注组id
     */
    hoverGroupId: string | undefined;
    /**
     * 元素id和批注组id list
     */
    commentGroupIdsMap: ICommentGroupIdMap;
    /**
     * 显示批注标记
     */
    isCommentAnchorShown: boolean;
    /**
     * 新批注红点提醒
     */
    isCommentNotifyFlagShown: boolean;
    /**
     * 设置是否默认显示批注标记
     */
    setIsCommentAnchorShown(isCommentAnchorShown: boolean): void;
    /**
     * 设置是否显示批注变更通知：包括更新和新增批注
     */
    setCommentNotifyFlagShown(isCommentNotifyFlagShown: boolean): void;
    /**
     * 设置批注侧边栏hover态的批注组id
     */
    setHoverGroupId(hoverGroupId: string | undefined): void;
    /**
     * 设置激活态的批注组id
     */
    setActiveGroupId(activeGroupId: string | undefined): void;
    /**
     * 设置编辑区hover的批注角标对应的元素id
     */
    setHoverElementId(hoverElementId: string | undefined): void;
    /**
     * 激活元素对应的批注组的第n个批注组
     */
    setActiveGroupIdForElement(elementId: string, activeGroupIndex?: number): void;
    /**
     * 获取批注后台的批注内容
     */
    getComments(groupId: string): Promise<ICommentWithVipInfo[] | undefined>;
    /**
     * 新增批注组
     */
    addCommentGroup(): IAddCommentGroup | undefined;
    /**
     * 删除当前页所有批注
     */
    deletePageComment(): void;
    /**
     * 删除文档所有批注
     */
    deleteAllComment(): void;
    /**
     * 上一条批注
     */
    jumpToPrevComment(): void;
    /**
     * 下一条批注
     */
    jumpToNextComment(): void;
    /**
     * 获取文档批注总数
     */
    getCommentCount(): number;
    /**
     * 是否是当前批注组的owner。默认创建第一条批注的用户为owner，同时文档owner是所有批注组的owner，即拥有操作该批注组的权限
     */
    isCommentGroupOwner(groupId: string): boolean;
    /**
     * 获取用户信息map
     */
    getCommentGroupInfoMap(slideId: string | null): CommentGroupInfoMap | undefined
    setServiceDelegates(services: IBaseCommentManagerServiceDelegates): void;
}
export interface IBaseCommentManagerServiceDelegates {
    selectionService: ISelectionService;
}

export type IAddCommentGroup = {
    commentGroupInfoMap: CommentGroupInfoMap;
    pendingCommentGroup: PendingCommentGroup;
};

export type GroupId = string;
export type CommentGroupInfoMap = Map<GroupId, ICommentWithVipInfo[]>;

export type SlideId = string;
export type ElementId = string;
export type CommentGroupInfoCache = Map<SlideId, CommentGroupInfoMap>;

export type ICommentGroupIdMap = Map<ElementId | SlideId, GroupId[]>;

/**
 * 添加/更新/删除批注
 */
export enum CommentActionType {
    Add,
    Update,
    Delete,
}

/**
 * 调用批注接口之后的回调参数
 */
export interface ICommentActionCallbackProps {
    commentActionType: CommentActionType,   // 接口来源
    isCommentGroup?: boolean,   // 是否是批注组还是单条批注
    isFirstComment?: boolean    // 是否是首条批注
}
